import { render, staticRenderFns } from "./NotificationNewsAndUpdates.vue?vue&type=template&id=2ec164d2&scoped=true&"
import script from "./NotificationNewsAndUpdates.vue?vue&type=script&lang=js&"
export * from "./NotificationNewsAndUpdates.vue?vue&type=script&lang=js&"
import style0 from "./NotificationNewsAndUpdates.vue?vue&type=style&index=0&id=2ec164d2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec164d2",
  null
  
)

export default component.exports